import { useState } from 'react';

import { Button, Icon, Input, Select } from '@/components/ui';

import type { EditableFieldType } from './FieldRow';

const TYPE_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'textarea', label: 'Long text' },
  { value: 'email', label: 'Email' },
  { value: 'tel', label: 'Phone' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'select', label: 'Single select' },
  { value: 'url', label: 'URL' },
];

interface AddCustomFieldProps {
  /** Section label, e.g. "Profile" — used in the prompt text. */
  section: string;
  onAdd: (name: string, type: EditableFieldType) => void;
}

export function AddCustomField({ section, onAdd }: AddCustomFieldProps) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [type, setType] = useState<EditableFieldType>('text');

  if (!open) {
    return (
      <button type="button" className="add-field" onClick={() => setOpen(true)}>
        <Icon name="plus" size={14} />
        Add custom field to {section}
      </button>
    );
  }

  const submit = () => {
    if (!name.trim()) return;
    onAdd(name.trim(), type);
    setName('');
    setType('text');
    setOpen(false);
  };

  return (
    <div
      className="add-field"
      style={{
        background: 'var(--surface)',
        cursor: 'default',
        flexWrap: 'wrap',
        gap: 8,
        padding: '12px 18px',
      }}
    >
      <Input
        autoFocus
        style={{ flex: 1, minWidth: 200, height: 30 }}
        placeholder="Field name (e.g. Specialization)"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit();
          if (e.key === 'Escape') setOpen(false);
        }}
      />
      <Select
        value={type}
        onChange={(e) => setType(e.target.value as EditableFieldType)}
        options={TYPE_OPTIONS}
        style={{ width: 130, height: 30 }}
      />
      <Button variant="secondary" size="sm" onClick={() => setOpen(false)}>
        Cancel
      </Button>
      <Button variant="primary" size="sm" disabled={!name.trim()} onClick={submit} leftIcon={<Icon name="plus" size={12} />}>
        Add field
      </Button>
    </div>
  );
}
